import { generateId } from './ids';

const SESSION_KEY = 'mnn_session_id';

// One id per browser tab session, mirroring fs-assistant's sessionManager.
export function getSessionId() {
  try {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = generateId();
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch {
    return generateId();
  }
}
